export const buildYMapBundlePath = (key = ''): string => {
  const url = new URL('https://api-maps.yandex.ru/2.1/?lang=ru_RU');
  const params = new URLSearchParams(url.search);
  if (process.env.NODE_ENV !== 'production') {
    params.set('mode', 'debug');
  } else {
    params.set('apikey', key);
  }
  url.search = params.toString();

  return url.toString();
};
